import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { OperationType } from "common/constants/sm-constants";
import { PrivacyModel } from "common/models/page-models/privacy/privacy-data-model";
import { RouteEnvelope, WidgetModel } from "common/models/utility-models/base-model";
import { FormResolverService } from "common/resolvers/core-resolvers/form-resolver";
import { SystemService } from "common/services/core-services/system.service";
import { PrivacyWidgetService } from "common/widget/privacy/privacy-widget.service";

@Injectable({
    providedIn: 'root'
})
export class PrivacyResolver extends FormResolverService<PrivacyModel> {
    constructor(protected ws: PrivacyWidgetService, protected override router: Router, protected ss: SystemService) {
        super(ws, router, ss);
    }

    override manageState() {
   
        // console.log(this.aRoute.queryParams);
        const envelope = new RouteEnvelope();
        envelope.type = OperationType.VIEW;
    
        
        // envelope.transferData.transferData = this.getQueryParam();
        return envelope;
      }
}
